import { OnInit } from '@angular/core';
// Libraries
import {
  Component,
  ViewContainerRef
} from '@angular/core';
import { Angular2TokenService } from 'angular2-token';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';

// Api config
import { ApiConfig } from './woopa-ui/api/config/api-config';

// Import base style
import '../style/app.scss';

import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

/**
 * `AppComponent` implements the main view.
 */
@Component({
  selector: 'she-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent implements OnInit {
  /**
   * Creates a new `AppComponent` instance.
   */
  constructor(
    private apiConfig: ApiConfig,
    private tokenService: Angular2TokenService,
    private toastr: ToastsManager,
    private viewContainerRef: ViewContainerRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    // Init token service
    this.tokenService.init({
      apiPath: this.apiConfig.urlAPI,
      signInRedirect: '/login',
      signInPath: 'user/auth/sign_in',
      signOutPath: 'user/auth/sign_out',
      validateTokenPath: 'user/auth/validate_token',
      updatePasswordPath: 'user/auth/password',
      resetPasswordPath: 'user/auth/password',
      resetPasswordCallback: window.location.origin + '/#/login/reset',
      globalOptions: {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    });

    // Init toast service
    this.toastr.setRootViewContainerRef(this.viewContainerRef);
  }

  /**
   * Implements on init method.
   */
  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map(route => {
        while (route.firstChild) {
         route = route.firstChild;
        }
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .subscribe((route) => {
        let params = route.snapshot.params;
        let title = route.snapshot.data.title;
        // Replace each param on page title
        _.forEach(params, (paramValue, paramKey) => {
          title = title.replace('%' + paramKey.toUpperCase() + '%', paramValue);
        });
        // Set title
        this.titleService.setTitle(title);
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.component.ts